// Recovered compiled webpack factory 38719. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "refreshReducer", {
      enumerable: !0,
      get: function () {
        return h;
      },
    }));
  let n = r(32753),
    a = r(29658),
    o = r(60895),
    i = r(44707),
    s = r(35737),
    l = r(11126),
    u = r(30637),
    c = r(17297),
    f = r(97332),
    d = r(48915),
    p = r(23597);
  function h(e, t) {
    let { origin: r } = t,
      h = {},
      _ = e.canonicalUrl,
      m = e.tree;
    h.preserveCustomHistoryState = !1;
    let g = (0, c.createEmptyCacheNode)(),
      y = (0, d.hasInterceptionRouteInCurrentTree)(e.tree);
    g.lazyData = (0, n.fetchServerResponse)(new URL(_, r), {
      flightRouterState: [m[0], m[1], m[2], "refetch"],
      nextUrl: y ? e.nextUrl : null,
    });
    let v = Date.now();
    return g.lazyData.then(
      async (r) => {
        let { flightData: n, canonicalUrl: c } = r;
        if ("string" == typeof n) return (0, s.handleExternalUrl)(e, h, n, e.pushRef.pendingPush);
        for (let r of ((g.lazyData = null), n)) {
          let { tree: n, seedData: l, head: d, isRootRender: b } = r;
          if (!b) return (console.log("REFRESH FAILED"), e);
          let E = (0, o.applyRouterStatePatchToTree)([""], m, n, e.canonicalUrl);
          if (null === E) return (0, f.handleSegmentMismatch)(e, t, n);
          if ((0, i.isNavigatingToNewRootLayout)(m, E))
            return (0, s.handleExternalUrl)(e, h, _, e.pushRef.pendingPush);
          let R = c ? (0, a.createHrefFromUrl)(c) : void 0;
          if ((c && (h.canonicalUrl = R), null !== l)) {
            let e = l[1],
              t = l[3];
            ((g.rsc = e),
              (g.prefetchRsc = null),
              (g.loading = t),
              (0, u.fillLazyItemsTillLeafWithHead)(v, g, void 0, n, l, d, void 0),
              (h.prefetchCache = new Map()));
          }
          (await (0, p.refreshInactiveParallelSegments)({
            navigatedAt: v,
            state: e,
            updatedTree: E,
            updatedCache: g,
            includeNextUrl: y,
            canonicalUrl: h.canonicalUrl || e.canonicalUrl,
          }),
            (h.cache = g),
            (h.patchedTree = E),
            (m = E));
        }
        return (0, l.handleMutable)(e, h);
      },
      () => e,
    );
  }
  (r(66048),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
